/**
 * Author bio enhancements for the single post / page template.
 *
 * @module
 */

export class AuthorBio {
    /**
     * Display the author bio on a tooltip.
     *
     * @param {Element} container
     */
    constructor(container) {
        /** @type {HTMLElement} */
        // @ts-ignore: cannot easily cast to HTMLElement
        this.container = container;
        this.$ = sel => container.querySelector(sel);
        this.isDisplaying = false;
    }

    /**
     * Initialize the author bio feature.
     *
     * 1. Add the down arrow to display the bio.
     * 2. Enable the popup on arrow click or hover.
     *
     * @return {void}
     */
    init() {
        this.findElements();
        if (!this.hasDescription()) {
            return;
        }
        this.name.insertAdjacentHTML('beforeend', `<span class="description-arrow">❯</span>`);
        window.requestAnimationFrame(() => this.initToggler());
    }

    /**
     * Find the author bio elements in the document.
     *
     * @private
     * @return {void}
     */
    findElements() {
        this.name = this.$('.abh_name');
        this.description = this.$('.abh_description');
    }

    /**
     * Does the post author have a bio?
     *
     * @private
     * @return {boolean}
     */
    hasDescription() {
        return this.description && this.description.textContent.trim().length > 0;
    }

    /**
     * Display the bio.
     *
     * @private
     * @return {void}
     */
    show() {
        this.isDisplaying = true;
        this.container.dataset.showDescription = 'true';
    }

    /**
     * Hide the bio.
     *
     * @private
     * @return {void}
     */
    hide() {
        this.isDisplaying = false;
        this.container.dataset.showDescription = 'false';
    }

    /**
     * Toggle the bio.
     *
     * @private
     * @return {void}
     */
    toggle() {
        return this.isDisplaying ? this.hide() : this.show();
    }

    /**
     * Show the bio on toggler click or hover.
     *
     * @private
     * @return {void}
     */
    initToggler() {
        this.toggler = this.name.lastElementChild;
        this.toggler.addEventListener('click', () => this.toggle());
        // @ts-ignore: global var
        hoverintent(
            this.toggler,
            () => this.show(),
            () => this.hide()
        ).options({
            timeout: 500,
        });
    }
}
